import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-youtube-competitor-checklist',
  templateUrl: './help-youtube-competitor-checklist.component.html'
})
export class HelpYoutubeCompetitorChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
